import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getGrAjeerData } from "../../../../store/Api";
import ListGRAjeer from "./GRAjeerList";
import { setBreadCrumb } from "../../../../store/userSlice";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";

export default function GRAjeer() {
  const title = [{ label: "AJEER", link: "/dashboard/ajeer-gr" }];

  useEffect(() => {
    dispatch(setBreadCrumb(title));
  }, []);

  const Client = useSelector((state) => state.grAjeer);

  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");

  useEffect(() => {
    dispatch(getGrAjeerData(token));
  }, []);

  const updateData = () => {
    dispatch(getGrAjeerData(token));
  };

  return (
    <>
      <div className={`p-2 `}>
        <ListGRAjeer
          list={Client}
          titles={[
            "SR.NO.",
            "employee ID",
            "employee NAME",
            "SPONSOR",
            "CLIENT NAME",
            "IQAMA NUMBER",
            "AJEER LOCATION ENGLISH",
            "AJEER LOCATION ARABIC",
            "AJEER APPLY DATE",
            "AJEER ISSUE DATE",
            "AJEER EXPIRE DATE",
            "AJEER VALID DAYS",
            "AJEER FEE",
            "STATUS",
            "ACTION",
          ]}
          token={token}
          updateData={updateData}
        />


      </div>
    </>
  );
}
